/**
 * Treat the typed query as one search term. Every token must match
 * (so "red light sauna" is a sauna with a red-light feature, not two
 * separate groups). Rank phrase matches first, then Vyvata Score.
 */
(function (root) {
  const STOP = new Set([
    'a', 'an', 'the', 'and', 'or', 'of', 'for', 'with', 'to', 'in', 'on', 'at',
    'vs', 'by', 'from',
  ]);

  function escapeRe(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function tokenize(query) {
    return String(query || '')
      .toLowerCase()
      .replace(/[^\p{L}\p{N}+.\s-]/gu, ' ')
      .split(/[\s+]+/)
      .map((w) => w.trim())
      .filter(Boolean);
  }

  function queryTokens(query) {
    return tokenize(query).filter((w) => !STOP.has(w) && w.length > 1);
  }

  function normalizeHay(text) {
    return String(text || '').toLowerCase().replace(/[_/,]+/g, ' ');
  }

  function matchesTerm(text, term) {
    if (!text || !term) return false;
    const needle = String(term).toLowerCase().trim();
    if (!needle) return false;
    return new RegExp('(?:^|[^a-z0-9])' + escapeRe(needle), 'i').test(normalizeHay(text));
  }

  /** The full query is one item: every token must be present. */
  function matchesFullQuery(text, query) {
    const tokens = queryTokens(query);
    if (!tokens.length) return false;
    return tokens.every((t) => matchesTerm(text, t));
  }

  /**
   * 2 = consecutive phrase ("red light sauna")
   * 1 = all tokens present, not consecutive
   * 0 = not a match
   */
  function termRank(text, query) {
    if (!matchesFullQuery(text, query)) return 0;
    const phrase = queryTokens(query).join(' ');
    if (phrase && matchesTerm(text, phrase)) return 2;
    return 1;
  }

  function scoreOf(elOrProduct) {
    if (elOrProduct == null) return 0;
    if (typeof elOrProduct.score === 'number') return elOrProduct.score || 0;
    const raw =
      elOrProduct.getAttribute?.('data-score') ||
      elOrProduct.querySelector?.('[data-score]')?.getAttribute('data-score') ||
      '0';
    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
  }

  function compareByScoreDesc(a, b) {
    return scoreOf(b) - scoreOf(a);
  }

  function compareByTermThenScore(a, b, query, textOf) {
    const getText = textOf || ((x) => x.text || x.blob || x.title || '');
    const ra = termRank(getText(a), query);
    const rb = termRank(getText(b), query);
    if (rb !== ra) return rb - ra;
    return scoreOf(b) - scoreOf(a);
  }

  const api = {
    STOP,
    tokenize,
    queryTokens,
    matchesTerm,
    matchesFullQuery,
    termRank,
    scoreOf,
    compareByScoreDesc,
    compareByTermThenScore,
  };

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  root.VSFSearchTerms = api;
})(typeof window !== 'undefined' ? window : globalThis);
